const AppLogo = () => {
  return (
    <img src="/images/logo-general.png" alt="Logo" style={ {
      objectFit: 'contain',
      objectPosition: 'center'
    } } />
  );
};

export default AppLogo;
